// Der Zähler unter der Kurzvorstellung auf /konto.
//
// Kein React-Komponent: die Kontoseite ist server-gerendert, und eine
// React-Wurzel für einen Text, der „noch 480 Zeichen" sagt, wäre ein Bundle
// mehr für zwei Zahlen. Das Zählen selbst ist eine reine Funktion, damit es
// ohne DOM getestet werden kann (vitest läuft hier in `node`), das Anhängen
// an die Seite eine zweite, die nichts entscheidet.
//
// Der Zähler ist bewusst `aria-hidden`: das Feld trägt `maxlength`, mehr geht
// gar nicht erst hinein, und die Grenze steht als Text im `field__hint`, den
// ein Screenreader beim Betreten des Feldes vorliest. Eine Live-Region, die
// bei jedem Tastendruck „noch 479, noch 478" ansagt, wäre das Gegenteil von
// Hilfe.

export function counterText(used: number, max: number): string {
  const left = Math.max(0, max - used)

  if (left === 0) return 'Kein Zeichen mehr frei'
  if (left === 1) return 'Noch 1 Zeichen'

  return `Noch ${left} Zeichen`
}

export function startCharacterCounters(root: ParentNode = document): void {
  const fields = root.querySelectorAll<HTMLTextAreaElement | HTMLInputElement>('[data-character-counter]')

  fields.forEach((field) => {
    const target = root.querySelector<HTMLElement>(`#${field.dataset.characterCounter ?? ''}`)
    if (!target) return

    const max = Number(field.getAttribute('maxlength'))
    if (!Number.isFinite(max) || max <= 0) return

    const update = (): void => {
      target.textContent = counterText(field.value.length, max)
    }

    field.addEventListener('input', update)
    update()
  })
}
